import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { userData } from 'src/app/models/user-model';
import { LocalStorageService } from 'angular-web-storage';
import { LoadingService } from 'src/app/components/loading/loading-service.service';


@Injectable({
  providedIn: 'root'
})

export class SessionService {

  userData!: userData
  Token: any;
  UF: any;

  constructor(private api: ApiService, private storage: LocalStorageService, private route: Router, private loader: LoadingService) { 

    this.getSession()
    
  }

  

  getSession(){

          const data = this.storage.get('userData')
       
          if(this.storage.get('userData')){


            if(typeof(data.PoliticamenteExposto) != 'object' || data.InformacoesBancarias == null){

              data.PoliticamenteExposto = {}
 
            }
 
            if(typeof(data.OrgaoExpedidor) != 'object' || data.OrgaoExpedidor == null){
 
             data.OrgaoExpedidor = {}
 
            }
 
            if(typeof(data.InformacoesBancarias) != 'object' || data.InformacoesBancarias == null){
 
              data.InformacoesBancarias = {}
 
            }
 
            this.userData = data

          }
           

     
  }

  getUserData(){

       return this.storage.get('userData')

  }

  getToken(){

   return this.storage.get('Token')

  }

  update(){

    this.storage.set('userData', this.userData)

  }


  logout(){

    const body = {
      requisicao:{
        Token: this.getToken()
      }
    }

    this.loader.startLoading()
    this.api.query('/auth/logout', body, 'post')?.subscribe((data) => {

      const apiName = this.api.getEnvironment();
      this.storage.clear()
      if(apiName){
        this.api.setEnvironment(apiName);
      }          

      this.route.navigate(['/login']).then(()=>{
        window.location.reload();
        this.loader.stopLoading()
      })

    })
        
  }

  
}

